<footer>
    <section class="bg-dark text-light ">
        <div class="container p-5">
            <div class="d-flex align-items-center justify-content-between mx-sm-5 ">
                <h6>Connect with us!</h6>
                <div>
                    <a href="https://www.facebook.com/jack.paul.3413 "><img class=" img-fluid w-25" src="../../assets/img/fb.png " alt="facebook "></a>
                    <a href="https://www.youtube.com/channel/UCm1nXvwAYbgfNBxZipon1_w?view_as=subscriber "><img class=" img-fluid w-25" src="../../assets/img/yt.png " alt="youtube "></a>
                    <a href="https://www.instagram.com/jack_paul/ "><img class=" img-fluid w-25" src="../../assets/img/insta.png " alt="instagram "></a>
                    <a href="https://github.com/Jack-Paul "><img class="img-fluid w-25" src="../../assets/img/git.png " alt="Github "></a>
                </div>
            </div>
        </div>
    </section>
</footer>